define("preview-grid/routes/application", ["exports", "@ember/routing/route", "@ember/array", "@ember/service", "nprogress", "@ember/object/computed", "later/errors/invalid-credentials-error", "later/utils/promise-hash"], function (_exports, _route, _array, _service, _nprogress, _computed, _invalidCredentialsError, _promiseHash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _route.default.extend({
    auth: (0, _service.inject)(),
    alerts: (0, _service.inject)(),
    intl: (0, _service.inject)(),
    instagram: (0, _service.inject)(),
    instagramBusiness: (0, _service.inject)('social/instagram-business'),
    router: (0, _service.inject)(),
    schedule: (0, _service.inject)(),
    segment: (0, _service.inject)(),
    errors: (0, _service.inject)(),
    store: (0, _service.inject)(),
    selectedSocialProfiles: (0, _service.inject)(),
    dialogManager: (0, _service.inject)(),
    postLimit: 60,
    errorList: (0, _array.A)([]),
    fallbackProfile: null,
    currentAccount: (0, _computed.readOnly)('auth.currentAccount'),
    currentGroup: (0, _computed.readOnly)('auth.currentGroup'),
    currentUser: (0, _computed.readOnly)('auth.currentUserModel'),
    socialProfile: (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'),

    activate() {
      this.schedule.setSideLibraryBehavior('preview');

      if (this.socialProfile.get('isInstagram')) {
        this.segment.track('viewed-preview-grid', {
          ig_profile: '@' + this.socialProfile.get('nickname')
        });
      }
    },

    beforeModel() {
      if (this.socialProfile.needsRefresh) {
        this.alerts.warning(this.intl.t('alerts.errors.must_refresh_credentials.message', {
          feature: 'preview'
        }), {
          title: this.intl.t('shared_phrases.refresh_your_connection')
        });
        this.router.transitionTo('account.groups.group', this.currentGroup);
      } else if (!this.socialProfile.isInstagram) {
        this.alerts.warning(this.intl.t('alerts.preview_grid.non_ig.message', {
          feature: 'preview'
        }), {
          title: this.intl.t('alerts.preview_grid.non_ig.title')
        });
        this.router.transitionTo('account.groups.group.social_profiles', this.auth.currentGroup.id);
      } else if (this.get('currentAccount.stopTheWorld')) {
        this.router.transitionTo('cluster.schedule');
      }
    },

    async model() {
      const maxNumOfPostsFromPagination = 8;

      if (!this.socialProfile.isInstagram) {
        throw new Error('Attempted to access preview with non-ig profile: ' + this.socialProfile.id);
      }

      this.fallbackProfile = this.socialProfile;
      this.schedule.updatePostLimit.perform();
      return (0, _promiseHash.default)({
        igPosts: this.instagram.fetchRecentMedia(this.socialProfile, {
          count: this.postLimit
        }).then(response => {
          var _response$pagination;

          if (!(response !== null && response !== void 0 && (_response$pagination = response.pagination) !== null && _response$pagination !== void 0 && _response$pagination.next)) {
            return response.posts;
          }

          return this.instagram.fetchRecentMedia(this.socialProfile, {
            count: this.postLimit
          }, response.pagination).then(responseWithPagination => [...response.posts, ...responseWithPagination.posts.slice(0, maxNumOfPostsFromPagination)]);
        }, error => {
          if (error.code === 429) {
            this.errorList.push('rateLimitError');
          } else if (error instanceof _invalidCredentialsError.default) {
            this.errorList.push(error);
          }

          this.errorList.push('igPostError');
          return [];
        }),
        posts: this.store.query('gram', {
          query_type: 'preview',
          social_profile_id: this.socialProfile.id,
          limit: this.postLimit
        }).then(grams => grams, () => {
          this.errorList.push('scheduledPostError');
          return [];
        }),
        igUser: this.instagram.fetchSelf(this.socialProfile).catch(() => {
          this.errorList.push('igUserError');
          return {};
        })
      });
    },

    setupController(controller, model) {
      this._super(controller, model);

      const posts = this.store.peekAll('gram');
      const {
        postLimit,
        errorList,
        currentAccount
      } = this;
      controller.setProperties({
        igUser: model.igUser,
        igPosts: model.igPosts,
        socialProfile: this.socialProfile,
        posts,
        postLimit,
        errorList,
        currentAccount
      });

      if (this.errorList.find(error => error instanceof _invalidCredentialsError.default)) {
        this.alerts.alert(this.intl.t('alerts.errors.auto_publish.expired_token.message', {
          account_name: this.socialProfile.nickname
        }), {
          title: this.intl.t('shared_phrases.refresh_your_connection'),
          action: () => this.send('reconnectSocialProfile', this.socialProfile),
          actionText: this.intl.t('shared_words.refresh')
        });
      }
    },

    deactivate() {
      this.send('setSideLibraryBehavior', null);
    },

    actions: {
      error(error) {
        this.errors.log(error);
        return this.alerts.warning(this.intl.t('alerts.preview_grid.loading_error.message'), {
          title: this.intl.t('alerts.preview_grid.loading_error.title'),
          action: () => this.router.transitionTo('cluster.schedule.calendar'),
          actionText: this.intl.t('alerts.preview_grid.loading_error.button_text')
        });
      },

      editPost(gram_id) {
        this.router.transitionTo('cluster.schedule.calendar.calendar.post.edit', gram_id);
      },

      closeModal() {
        this.disconnectOutlet({
          outlet: 'modal',
          parentView: 'application'
        });
        this.router.transitionTo('cluster.schedule.preview-grid');
      },

      closePreview() {
        this.router.transitionTo('cluster.schedule.calendar');
      },

      addToPreview(mediaItemIds) {
        this.controller.addNewPreviewPosts({
          mediaItemIds,
          fromQuickSchedule: true
        });
      },

      changeProfile() {
        _nprogress.default.start();

        this.refresh();
        return true;
      },

      loading(transition
      /*, originRoute*/
      ) {
        if (this.controller) {
          this.controller.reset();
        }

        transition.promise.finally(() => {
          _nprogress.default.done();
        });
        return true;
      },

      willTransition(transition) {
        if (this.controller.hasEditedPosts) {
          transition.abort(); // Note: Although this aborts the transition - this will not safely handle situations where
          // other functionality accompanies the transition (for example, selectedSocialProfiles.addProfileAndTransition)

          this.dialogManager.confirm(this.intl.t('shared_phrases.close_warning'), {
            description: this.intl.t('preview_grid.confirm_unsaved'),
            confirmButton: this.intl.t('shared_words.leave')
          }).then(() => {
            this.controller.reset();
            transition.retry();
          }).catch(() => {
            // Note: If the dialog was prompted by selecting a new social profile, and the dialog was
            // then cancelled - we need to reset the selectedSocialProfiles to the original state and
            // prevent the transition from happening. We use selectExactly here as we do not want to trigger a
            // transition by using selectSingleProfile
            if (this.fallbackProfile) {
              this.selectedSocialProfiles.selectExactly([this.fallbackProfile]);
              this.dialogManager.rejectPromise('confirmation');
            }
          });
        }
      },

      launchQuickScheduleWizard() {
        this.send('quickScheduleWizard');
      },

      refreshConnection(socialProfile) {
        this.send('reconnectSocialProfile', socialProfile);
      },

      reloadRoute() {
        this.refresh();
      }

    }
  });

  _exports.default = _default;
});